import { i18n } from '@/i18n';
import { configuratiebeheerder, databeheerder, dataleverancier, systeembeheerder } from './roleTypes';
import { FeatureKeys, isFeatureEnabled } from '@/common/config/config';

export type IDomainConfiguration = {
    title: string;
    content: string;
    roles: string[];
    route: string;
    feature?: FeatureKeys;
    icon?: string;
};

const domainConfiguration: IDomainConfiguration[] = [
    {
        title: i18n.global.t('navigation.publications.title'),
        content: i18n.global.t('navigation.publications.subtitle'),
        roles: [dataleverancier,  systeembeheerder],
        route: '/publications',
        icon: 'publications',
        feature: 'publications'
    },
    {
        title: i18n.global.t('navigation.deliveries.title'),
        content: i18n.global.t('navigation.deliveries.subtitle'),
        roles: [databeheerder, systeembeheerder],
        route: '/delivery',
        icon: 'delivery'
    },
    {
        title: i18n.global.t('navigation.products.title'),
        content: i18n.global.t('navigation.products.subtitle'),
        roles: [databeheerder, systeembeheerder],
        route: '/product',
        icon: 'product'
    },
    {
        title: i18n.global.t('navigation.configuration.title'),
        content: i18n.global.t('navigation.configuration.subtitle'),
        roles: [configuratiebeheerder, systeembeheerder],
        route: '/configuration',
        feature: 'configuration',
        icon: 'configuration'
    }
];

const filterDomainByFeature = (domain) => {
    return domain.feature ? isFeatureEnabled(domain.feature) : true;
};

export const getDomainConfigurations = () => domainConfiguration.filter(filterDomainByFeature);
